import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "exam-result-layout"
}
const _hoisted_2 = { class: "exam-result-main" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "d-flex flex-wrap align-center result-title p-3 white-text" }
const _hoisted_5 = { class: "w-100" }
const _hoisted_6 = { class: "headline m-0 text-sm-start" }
const _hoisted_7 = { class: "d-flex w-full" }
const _hoisted_8 = { class: "d-flex justify-content-center align-center" }
const _hoisted_9 = { class: "align-center text-align-center" }
const _hoisted_10 = { class: "text-h3" }
const _hoisted_11 = { class: "d-flex w-full" }
const _hoisted_12 = { class: "text-sm-start w-30" }
const _hoisted_13 = { class: "mt-3" }
const _hoisted_14 = { class: "headline" }
const _hoisted_15 = { class: "caption" }
const _hoisted_16 = { class: "mt-3" }
const _hoisted_17 = { class: "caption" }
const _hoisted_18 = { class: "mt-3 d-none" }
const _hoisted_19 = {
  key: 0,
  class: "w-70"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "sidebar-content" }
const _hoisted_22 = {
  key: 2,
  style: {"padding-right":"40px"}
}
const _hoisted_23 = { class: "question-list-wrapper" }

import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import ChartProgress from './ChartProgress.vue'
import ExamSkillReport from './ExamSkillReport.vue'
import ExamSkillItemReport from './ExamSkillItemReport.vue'
import ExamEvaluationComponent from './ExamEvaluation.vue'
import ExamResultQuestionGroupList from './ExamResultQuestionGroupList.vue'
import Exam from '../../models/exam'
import { LETTER_FORMAT } from '../../utils/constants'
import { GroupQuestion } from '../../../api/v2/models/question'
import FbShareButton from './FbShareButton.vue'
import TwShareButton from './TwShareButton.vue'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import UserExam from '../../models/user_exam'
import Banner from '../../../api/v2/models/banner'
import { ExamQScoreHistory } from '../../../api/v2/models/q_score_history'
import MesageContainer from "../organisms/MesageContainer.vue"
import ThreadContainer from "../organisms/ThreadContainer.vue"
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import SkillsChart from "./SkillsChart.vue"

// Props
const STORAGE_KEY = 'exam_result_pane_size'

// Refs

export default /*@__PURE__*/_defineComponent({
  __name: 'ExamResultWeb',
  props: {
    exam: {},
    userExam: {},
    banners: {},
    groupQuestions: {},
    examQScoreHistory: {}
  },
  setup(__props: any) {

const props = __props

// Constants
const mesageContainer = ref<InstanceType<typeof MesageContainer> | null>(null)
const tab = ref<number | null>(null)
const bodyTab = ref<number | null>(props.exam.isShowEvaluation ? 0 : 1)
const leftPaneSize = ref<number>(loadPaneSize())

// Check if running in embed mode
const route = useRoute()
const isEmbed = computed(() => !!route.meta?.embed)

// Functions
function loadPaneSize(): number {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved) {
      const size = parseFloat(saved)
      if (!isNaN(size) && size >= 30 && size <= 80) {
        return size
      }
    }
  } catch (e) {
    console.warn('Failed to load pane size from localStorage:', e)
  }
  return 70 // Default size
}

function savePaneSize(size: number) {
  try {
    localStorage.setItem(STORAGE_KEY, size.toString())
  } catch (e) {
    console.warn('Failed to save pane size to localStorage:', e)
  }
}

function onPaneResized(panes: { size: number }[]) {
  if (panes.length >= 1) {
    leftPaneSize.value = panes[0].size
    savePaneSize(leftPaneSize.value)
  }
}

function getQuestionNumber(groupExamResultQuestion: GroupQuestion): number {
  return (
    props.groupQuestions
      .filter((item) => item.questions.every((question) => !question.isDescriptionQuestion))
      .indexOf(groupExamResultQuestion) + 1
  )
}

function getBanner(position: string): Banner | undefined {
  return props.banners?.find((banner) => banner.position === position)
}

function updateParentTab(value: number) {
  tab.value = value
}

function emitCreateThread(value: number) {
  if (typeof value === 'number') {
    tab.value = value
  }
  mesageContainer.value?.createThread()
}

// Computed
const schoolSetting = computed(() => headerState.schoolSetting)

const skills = computed(() => props.exam.examSkills)

const shareUrl = computed(() => `${window.location.origin}/exams/${props.exam.id}`)

const shareText = computed(() => `
${props.userExam.passed ? '合格しました！' : '残念ながら不合格です'}\n
正解率: ${props.userExam.average}%\n
平均: ${props.exam.averageRate}%\n
順位: ${props.userExam.position}位\n
`)

const sortedGroupQuest = computed(() => 
  [...props.groupQuestions].sort((a, b) => a.groupId - b.groupId)
)

const useAiChatExam = computed(() => {
  if (!schoolSetting.value) {
    return false
  }
  return schoolSetting.value.useAiChatExam
})

// Lifecycle
onMounted(async () => {
  if (!headerState.schoolSetting) {
    await headerState.getSchoolSetting()
  }
  headerState.setTitle(props.exam.name)
  footerState.setFooterDefault()
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list = _resolveComponent("v-list")!

  return (__props.userExam.finishedAt)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Splitpanes), {
          class: "default-theme",
          onResized: onPaneResized
        }, {
          default: _withCtx(() => [
            _createCommentVNode(" Main Content (Left) - Scrolls inside pane "),
            _createVNode(_unref(Pane), {
              size: leftPaneSize.value,
              "min-size": 30,
              class: "exam-result-main-pane"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (getBanner('exam_result_top'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "container p-4 container--fluid",
                        innerHTML: getBanner('exam_result_top').bodyHtml
                      }, null, 8 /* PROPS */, _hoisted_3))
                    : _createCommentVNode("v-if", true),
                  _createVNode(_component_v_card, { class: "p-0 exam-result-card" }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "result-head"),
                      _createVNode(_component_v_container, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("p", _hoisted_6, _toDisplayString(__props.exam.name), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_v_progress_circular, {
                                  class: "m-2",
                                  size: 150,
                                  width: 15,
                                  "model-value": __props.userExam.average,
                                  color: "white"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_9, [
                                      _createElementVNode("div", _hoisted_10, _toDisplayString(__props.userExam.average), 1 /* TEXT */),
                                      _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"margin-top":"-10px"} }, "%", -1 /* CACHED */))
                                    ])
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["model-value"])
                              ]),
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["exam-status-result pe-3 ps-3", {
                        pass: __props.userExam.passed,
                        failure: !__props.userExam.passed
                      }])
                                  }, [
                                    (__props.userExam.passed)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          color: "white"
                                        }, {
                                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                            _createTextVNode("mdi-check", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true),
                                    _createTextVNode(" " + _toDisplayString(__props.userExam.passed
                              ? _ctx.$t('exam_result.pass', {format: _unref(LETTER_FORMAT).UPTITLECASE})
                              : _ctx.$t('exam_result.failure', {format: _unref(LETTER_FORMAT).UPTITLECASE})), 1 /* TEXT */)
                                  ], 2 /* CLASS */),
                                  (!__props.exam.canRetest)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_13, [
                                          _createElementVNode("span", _hoisted_14, _toDisplayString(__props.userExam.position), 1 /* TEXT */),
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('exam_result.place')) + " ", 1 /* TEXT */),
                                          _createElementVNode("span", _hoisted_15, " / " + _toDisplayString(__props.exam.usersCount) + " " + _toDisplayString(_ctx.$t('exam_result.people')), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("div", _hoisted_16, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('exam_result.national_average', {format: _unref(LETTER_FORMAT).UPTITLECASE})) + ": ", 1 /* TEXT */),
                                          _createElementVNode("span", _hoisted_17, _toDisplayString(__props.exam.averageRate) + "% ", 1 /* TEXT */)
                                        ])
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("div", _hoisted_18, [
                                    _createVNode(FbShareButton, { url: shareUrl.value }, null, 8 /* PROPS */, ["url"]),
                                    _createVNode(TwShareButton, {
                                      url: shareUrl.value,
                                      text: shareText.value,
                                      class: "mt-1"
                                    }, null, 8 /* PROPS */, ["url", "text"])
                                  ])
                                ]),
                                (__props.exam.isShowEvaluation)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _createVNode(SkillsChart, {
                                        skills: skills.value,
                                        "user-exam": __props.userExam
                                      }, null, 8 /* PROPS */, ["skills", "user-exam"])
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ])
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _withDirectives(_createElementVNode("div", null, [
                        _createVNode(_component_v_tabs, {
                          modelValue: bodyTab.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bodyTab).value = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_tab, { key: "evaluation" }, {
                              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                _createTextVNode("診断結果", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_tab, { key: "skill" }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createTextVNode("スタッツ詳細", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                      ], 512 /* NEED_PATCH */), [
                        [_vShow, __props.exam.isShowEvaluation]
                      ]),
                      _createVNode(_component_v_tabs_window, {
                        modelValue: bodyTab.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((bodyTab).value = $event)),
                        class: "h-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_tabs_window_item, { value: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(ExamEvaluationComponent, {
                                examEvaluations: __props.exam.examEvaluations,
                                score: __props.userExam.average
                              }, null, 8 /* PROPS */, ["examEvaluations", "score"])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_v_tabs_window_item, { value: 1 }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skills.value, (skill, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                  _createVNode(ExamSkillReport, {
                                    skill: skill,
                                    userExam: __props.userExam
                                  }, null, 8 /* PROPS */, ["skill", "userExam"]),
                                  (index + 1 < skills.value.length)
                                    ? (_openBlock(), _createBlock(_component_v_divider, {
                                        class: "m-0",
                                        key: index + skill.name
                                      }))
                                    : _createCommentVNode("v-if", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skill.skillItems, (skillItem, indexItem) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: skillItem.name + indexItem
                                    }, [
                                      _createVNode(ExamSkillItemReport, {
                                        skillItem: skillItem,
                                        userExam: __props.userExam
                                      }, null, 8 /* PROPS */, ["skillItem", "userExam"]),
                                      (indexItem + 1 < skill.skillItems.length)
                                        ? (_openBlock(), _createBlock(_component_v_divider, {
                                            class: "m-0",
                                            key: index + skillItem.name + indexItem
                                          }))
                                        : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ], 64 /* STABLE_FRAGMENT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue"]),
                      _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "content-divider" }, null, -1 /* CACHED */)),
                      _renderSlot(_ctx.$slots, "result-body")
                    ]),
                    _: 3 /* FORWARDED */
                  }),
                  (getBanner('exam_result_bottom'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "container p-4 container--fluid",
                        innerHTML: getBanner('exam_result_bottom').bodyHtml
                      }, null, 8 /* PROPS */, _hoisted_20))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["size"]),
            _createCommentVNode(" Sidebar (Right) - Scrolls inside pane "),
            _createVNode(_unref(Pane), {
              size: 100 - leftPaneSize.value,
              "min-size": 20,
              class: "exam-result-sidebar-pane"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "p-0 sidebar-card" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_v_tabs, {
                        modelValue: tab.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tab).value = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_tab, { key: "question" }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode("Questions", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }),
                          (useAiChatExam.value)
                            ? (_openBlock(), _createBlock(_component_v_tab, { key: "chat" }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                  _createTextVNode("チャット", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              }))
                            : _createCommentVNode("v-if", true),
                          (useAiChatExam.value)
                            ? (_openBlock(), _createBlock(_component_v_tab, { key: "thread" }, {
                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                  _createTextVNode("スレッド", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              }))
                            : _createCommentVNode("v-if", true),
                          (useAiChatExam.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                            : _createCommentVNode("v-if", true),
                          (useAiChatExam.value)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 3,
                                class: "btn-new-chat",
                                icon: true,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (emitCreateThread(1)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                      _createTextVNode("mdi-comment-plus", -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              }))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue"]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_v_tabs_window, {
                          modelValue: tab.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tab).value = $event)),
                          class: "h-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_tabs_window_item, {
                              value: 0,
                              class: "question-tab-content"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list, { class: "report-list" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedGroupQuest.value, (item, index) => {
                                      return (_openBlock(), _createBlock(ExamResultQuestionGroupList, {
                                        key: index + 'group',
                                        item: item,
                                        padding: true,
                                        questionNumber: getQuestionNumber(item),
                                        exam: __props.exam,
                                        "user-exam": __props.userExam,
                                        examQScoreHistory: __props.examQScoreHistory
                                      }, null, 8 /* PROPS */, ["item", "questionNumber", "exam", "user-exam", "examQScoreHistory"]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }),
                            (useAiChatExam.value)
                              ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                                  key: 0,
                                  value: 1,
                                  class: "question-tab-content"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(), _createBlock(MesageContainer, {
                                      ref_key: "mesageContainer",
                                      ref: mesageContainer,
                                      key: __props.exam.id,
                                      targetableId: __props.exam.id,
                                      targetableType: 'Exam',
                                      "using-deepseek": schoolSetting.value?.usingDeepSeek,
                                      class: "h-full"
                                    }, null, 8 /* PROPS */, ["targetableId", "using-deepseek"]))
                                  ]),
                                  _: 1 /* STABLE */
                                }))
                              : _createCommentVNode("v-if", true),
                            (useAiChatExam.value)
                              ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                                  key: 1,
                                  value: 2,
                                  class: "question-tab-content"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(), _createBlock(ThreadContainer, {
                                      key: __props.exam.id,
                                      targetableId: __props.exam.id,
                                      targetableType: 'Exam',
                                      onUpdateParentTab: updateParentTab,
                                      class: "h-full"
                                    }, null, 8 /* PROPS */, ["targetableId"]))
                                  ]),
                                  _: 1 /* STABLE */
                                }))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                      ])
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["size"])
          ]),
          _: 3 /* FORWARDED */
        })
      ]))
    : _createCommentVNode("v-if", true)
}
}

})